import { render } from "./New_AlternativeUomPopup.vue?vue&type=template&id=380d6660"
import script from "./New_AlternativeUomPopup.vue?vue&type=script&lang=js"
export * from "./New_AlternativeUomPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__